import Card from "./card";

import View from "backdraft-app/src/view";

export default class CardDeck extends View {
  get body() {
    return "<div data-mount='cards' class='card-deck card-landscape'/>";
  }

  constructor(options) {
    super(options);

    this.cards = [];
    options.cards.forEach((config, index) => {
      this.cards.push(this.child(index, new Card({ config })));
    });
  }

  render() {
    super.render();

    this.$el.html(this.body);
    const target = this.$('[data-mount="cards"]');
    this.cards.forEach(card => {
      target.append(card.render().$el);
    });

    return this;
  }
}
